import ContextTemplate from './context.template';

let initialState = { kpiLinks: [] };
const reducer = (prevState = initialState, action) => {
  switch (action.type) {
    case 'SET_KPI':
      return { ...prevState, kpiLinks: action.payload };
    default:
      return prevState;
  }
};

const fetchKpiLinks = (dispatch) => {
  return (payload) => {
    dispatch({ type: 'SET_KPI', payload: payload });
  };
};

const action = { fetchKpiLinks };

const [context, provider] = ContextTemplate(reducer, action, initialState);

export { context, provider };
